<ng-container>
  <div class="field-container">
    <label *ngIf="visibleLabel" class="form-label">{{label}}</label>
    <p-tag [ngClass]="textLeft ? 'text-left' : ''" [icon]="icon" [severity]="severity" [rounded]="rounded"
      [value]="value" />
  </div>
</ng-container>